<template>
	<div id="test" onbeforeunload="return myFunction()">
		<div @click="alert">{{ count }}</div>
		<h1>haishikeyi</h1>
	</div>
</template>
<script>
export default {
	data() {
		return {
			count: 0
		};
	},
	methods: {
		alert() {
			alert('11111111111111');
				localStorage.setItem('type',localStorage.getItem('close')) 
			
			if (!localStorage.getItem('close')) {
				localStorage.setItem('closes', 1);
				localStorage.setItem('close', 1);
			} else {
				let localStorage1 = localStorage.getItem('close')
				localStorage.setItem('close',localStorage1++)
			}
		}
	},
	mounted() {
		window.addEventListener('beforeunload', e => this.alert(e));
	},

	// 路由改变时保存进度，关闭WebSocket连接，清除定时器
	beforeRouteLeave: function(to, from, next) {
		this.alert();

		// 路由跳转
		next();
	},

	destroyed() {
		// 移除关闭窗口事件
		window.removeEventListener('beforeunload', e => this.alert(e));
		window.removeEventListener('unload', e => this.alert(e));
	}
};
</script>
